import React from 'react';
import { LocationCard } from '../../../../location/card/LocationCard';
import { LocationPage } from '../../../../../pages/location/LocationPage';
import { XRouterLink } from '@orderx/lab/ui';
import { RootIdPage } from '../../../../../pages/id/RootIdPage';
import { Location } from '../../../../../XV2';

interface Props {
    feedItemId: number;
    location: Location;
}

export function BrowseFeedItemLocation({ location }: Props) {
    const to = location.browseTagId
        ? [RootIdPage, { id: location.browseTagId }]
        : [LocationPage, { locationId: location.id }];

    return (
        <XRouterLink to={to}>
            <LocationCard name={location.name} image={location.imageBackground} isClosed={location.isClosed} />
        </XRouterLink>
    );
}
